import { createContext } from 'react';

export type DropZoneContextProps = {
  acceptedMimeTypes?: string[];
  maxFileSize?: number;
  onDropFiles?: (files: File[]) => void;
};

export const DropZoneContext = createContext<DropZoneContextProps>({});
